import { render, staticRenderFns } from "./DepartmentStudents.vue?vue&type=template&id=0fc87c1e"
import script from "./DepartmentStudents.vue?vue&type=script&lang=js"
export * from "./DepartmentStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports